<div class="components-tab">
  <multi-shipment-shipping-toggle [formGroup]="formGroup.controls.shippingToggle"></multi-shipment-shipping-toggle>

  <multi-shipment-recipients-block [formGroup]="formGroup.controls.recipientsBlock"></multi-shipment-recipients-block>

  <multi-shipment-gift-notes-block [formGroup]="formGroup.controls.giftNotesBlock"></multi-shipment-gift-notes-block>

  <multi-shipment-add-recipient-modal
    [formGroup]="formGroup.controls.addRecipientModal"></multi-shipment-add-recipient-modal>

  <multi-shipment-line-item-assignment-status
    [formGroup]="formGroup.controls.lineItemAssignmentStatus"></multi-shipment-line-item-assignment-status>
  <multi-shipment-section-banner
    sectionId="multi-shipment-contact-banner"
    title="Contact Section Banner"
    subtitle="Info box explaining the buyer's email is for order confirmations only, not the recipient's."
    placeholder="Use your own email below - we'll send the order confirmation and shipping updates there."
    [formGroup]="formGroup.controls.contactSectionBanner"></multi-shipment-section-banner>

  <multi-shipment-section-banner
    sectionId="multi-shipment-delivery-banner"
    title="Delivery Section Banner"
    subtitle="Info box explaining the buyer will configure their first recipient and can add more after."
    placeholder="Enter the delivery details for your first recipient below. You can add more recipients after."
    [formGroup]="formGroup.controls.deliverySectionBanner"></multi-shipment-section-banner>
</div>
